export default "__VITE_ASSET__nWJUPZrH__"